import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";


export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pathname, setPathname] = useState(window.location.pathname);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);

        const handlePathChange = () => {
            setPathname(window.location.pathname);
        };
        window.addEventListener("popstate", handlePathChange);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("popstate", handlePathChange);
        };
    }, []);

    const navLinks = [
       
    ];

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 bg-white backdrop-blur-lg border-b border-border/50 shadow flex items-center ${scrolled ? "scrolled" : ""}`}
        >
            <div className="flex items-center justify-center w-full m-2">
                <a href="/">
                    <img
                        src="/logo-hero.png"
                        alt="AutoD Multimarcas "
                        width={360}
                        height={200}

                    />
                </a>

                <div className="md:hidden">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="text-3xl text-white transition-colors duration-300"
                    >
                        {menuOpen ? <HiX /> : <HiMenu />}
                    </button>
                </div>

                <nav className="hidden md:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <ul className="flex items-center gap-6 font-semibold text-white">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className="text-sm font-medium text-foreground/70 hover:text-primary transition-colors uppercase tracking-wider"
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/*<div className="hidden md:block">
                    <Link to="/contato" className="bg-red-700 hover:bg-red-800 text-white px-4 py-2 rounded inline-block font-semibold transition-colors duration-300">
                        Fale Conosco
                    </Link>
                </div>*/}
            </div>

            {menuOpen && (
                <div className="absolute top-full left-0 w-full bg-black shadow-md md:hidden">
                    <ul className="flex flex-col items-start px-6 py-4 text-white font-semibold gap-4">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className={`block w-full py-2 border-b border-white ${pathname === link.href ? "text-blue-600" : ""
                                        }`}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
